import {
  format,
  parseISO,
  differenceInMinutes,
  differenceInHours,
  differenceInDays,
  differenceInYears,
  addYears,
} from 'date-fns'

export const formatDateTime = (isoString: string): string =>
  format(parseISO(isoString), 'MM/dd/yyyy HH:mm')

export const formatTimeElapsed = (isoString: string): string => {
  const past = parseISO(isoString)
  const now = new Date()
  const totalMinutes = differenceInMinutes(now, past)

  if (totalMinutes < 60) {
    return `${totalMinutes}m`
  }

  const hours = differenceInHours(now, past)

  if (hours < 24) {
    const remainingMinutes = totalMinutes - hours * 60
    return `${hours}h ${remainingMinutes}m`
  }

  const days = differenceInDays(now, past)

  if (days < 365) {
    const remainingHours = hours - days * 24
    return `${days}d ${remainingHours}h`
  }

  const years = differenceInYears(now, past)
  const dateAfterYears = addYears(past, years)
  const remainingDays = differenceInDays(now, dateAfterYears)
  const remainingHours =
    differenceInHours(now, dateAfterYears) - remainingDays * 24
  return `${years}y ${remainingDays}d ${remainingHours}h`
}
